import Base from "./_Base";

// rules 通过身份证号计算年龄
// "rules": [{
//   "event": "${mother.IDCARD}:change",
//   "target": {
//     "mother.NL": {
//       "props": {
//         "value": "getAgeFromIdCard(${mother.IDCARD}.value)"
//       }
//     }
//   }
// }]

// rules 落户方式变更引起联动
// "rules": [{
//   "condition": "${self.SBHK}.value.value === 'SMLH'",
//   "event": "${self.SBHK}:change",
//   "target": {
//     "self.HKSSX": {
//       "props": {
//         "value": "${mother.HKSSX}.value"
//       }
//     },
//     "self.HKZZ": {
//       "props": {
//         "value": "${mother.HKZZ}.value"
//       }
//     },
//     "self.CBD": {
//       "props": {
//         "value": "${mother.HKSSX}.value"
//       }
//     }
//   }
// }]

/**
 * 联动规则解析并应用
 */
export default class Rules extends Base {
  _type = "rules";

  parse = () => {
    const { rules } = this.schema;
    if (!rules || !rules.length) return;

    rules.forEach((rule) => {
      const { overwrite } = rule;
      const parsedEvent = this._parseEvent(rule.event);
      const parsedCondition = this._parseCondition(rule.condition || "true");
      const parsedTarget = this._parseTarget(rule.target, { overwrite });
      const parsedRequests = this._parseRequest(rule.requestIds);
      const parsedTrigger = this._parseTrigger(rule.trigger);
      const event = rule.disableParamsEvent
        ? this._mergeEvent(parsedEvent.event, parsedTarget.modalShowEvent)
        : this._mergeEvent(
            parsedEvent.event,
            parsedCondition.event,
            parsedTarget.event,
            parsedTarget.modalShowEvent
          );

      this._addListener({
        config: rule,
        event,
        func: ({ initial } = {}) => {
          if (parsedCondition.handler()) {
            if (this.isDetail) {
              parsedTarget.handler({ initial });
            } else {
              // 预处理
              parsedTarget.preHandler && parsedTarget.preHandler();

              parsedTarget.handler({ initial });
              parsedRequests.handler({ initial });
              parsedTrigger.handler();
            }
          }
        },
      });
    });
  };
}
